/* NOVURA theme JS v2 */
(function () {
  "use strict";
  document.documentElement.classList.add("js");

  /* ── Theme toggle ── */
  const root = document.documentElement;
  function applyTheme(t) {
    root.classList.toggle("light", t === "light");
    document.querySelectorAll("[data-theme-icon-sun]").forEach(el => el.style.display = t === "light" ? "none" : "block");
    document.querySelectorAll("[data-theme-icon-moon]").forEach(el => el.style.display = t === "light" ? "block" : "none");
  }
  try { applyTheme(localStorage.getItem("novura-theme") || "dark"); } catch (e) { applyTheme("dark"); }
  document.addEventListener("click", (e) => {
    if (!e.target.closest("[data-theme-toggle]")) return;
    const next = root.classList.contains("light") ? "dark" : "light";
    try { localStorage.setItem("novura-theme", next); } catch (err) {}
    applyTheme(next);
  });

  /* ── Header scroll ── */
  const header = document.querySelector(".nv-header");
  if (header) {
    const onScroll = () => header.classList.toggle("scrolled", window.scrollY > 60);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ── Mobile menu ── */
  const mobileMenu = document.querySelector(".nv-mobile-menu");
  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-menu-open]")) mobileMenu && mobileMenu.classList.add("open");
    if (e.target.closest("[data-menu-close]") || e.target.closest(".nv-mobile-links a")) mobileMenu && mobileMenu.classList.remove("open");
  });

  /* ── Reveal on scroll ──
     Only arm the animation if IntersectionObserver exists. We add .nv-anim to <html>
     FIRST (which is what makes .reveal go opacity:0), then immediately begin observing.
     If IO is unavailable or anything throws, we never add .nv-anim, so all content
     stays fully visible — the page can never end up blank because of this. */
  try {
    if ("IntersectionObserver" in window) {
      root.classList.add("nv-anim");
      const io = new IntersectionObserver((entries) => {
        entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); } });
      }, { rootMargin: "0px 0px -40px 0px" });
      const els = document.querySelectorAll(".reveal");
      els.forEach(el => io.observe(el));
      // Safety net: if for any reason an element is already in view but the observer
      // hasn't fired within 1.2s, reveal everything so nothing stays hidden.
      setTimeout(() => els.forEach(el => el.classList.add("in")), 1200);
    }
  } catch (e) {
    root.classList.remove("nv-anim");
  }

  /* ── Toast ── */
  let toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement("div"); toastEl.className = "nv-toast"; document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add("show");
    clearTimeout(toastEl._t); toastEl._t = setTimeout(() => toastEl.classList.remove("show"), 2500);
  }

  /* ── Money ── */
  const money = (cents) => {
    const val = (cents / 100).toFixed(2);
    const fmt = window.NovuraMoneyFormat || "€{{amount}}";
    return fmt.replace(/\{\{\s*[a-z_]+\s*\}\}/, val).replace(/<[^>]+>/g, "");
  };
  const moneyRound = (cents) => {
    const val = (cents / 100);
    const s = val % 1 === 0 ? val.toFixed(0) : val.toFixed(2);
    const fmt = window.NovuraMoneyFormat || "€{{amount}}";
    return fmt.replace(/\{\{\s*[a-z_]+\s*\}\}/, s).replace(/<[^>]+>/g, "");
  };

  /* ── Cart drawer ── */
  const drawer = {
    open() { document.body.classList.add("nv-drawer-open"); this.refresh(); },
    close() { document.body.classList.remove("nv-drawer-open"); },
    async refresh() {
      try {
        const res = await fetch("/cart.js"); const cart = await res.json();
        document.querySelectorAll("[data-cart-count]").forEach(el => { el.textContent = cart.item_count; el.dataset.count = cart.item_count; });
        const list = document.querySelector("[data-cart-items]");
        const foot = document.querySelector("[data-cart-foot]");
        if (!list) return;
        if (!cart.items.length) {
          list.innerHTML = '<div class="nv-drawer-empty"><p>Your bag is empty.</p></div>';
          if (foot) foot.style.display = "none";
          return;
        }
        if (foot) foot.style.display = "";
        const sub = document.querySelector("[data-cart-subtotal]");
        if (sub) sub.textContent = money(cart.items_subtotal_price);
        list.innerHTML = cart.items.map(it => `
          <div class="nv-line" data-key="${it.key}">
            <img src="${it.image ? it.image.replace(/(\.[a-zA-Z]+)(\?|$)/, "_160x160$1$2") : ""}" alt="">
            <div style="flex:1">
              <div class="nv-line-title">${it.product_title}</div>
              <div class="nv-line-meta">${it.variant_title && it.variant_title !== "Default Title" ? it.variant_title : ""}${it.properties && it.properties["Frame Color"] ? " · Frame: " + it.properties["Frame Color"] : ""}</div>
              <div class="nv-line-price">${money(it.final_line_price)}</div>
              <div class="nv-qty" style="margin-top:.5rem">
                <button data-qty-change="-1" aria-label="Decrease quantity">−</button>
                <span>${it.quantity}</span>
                <button data-qty-change="1" aria-label="Increase quantity">+</button>
              </div>
            </div>
            <button class="nv-line-remove" data-line-remove>Remove</button>
          </div>`).join("");
      } catch (e) {}
    },
    async change(key, qty) {
      await fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: key, quantity: qty }) });
      this.refresh();
    }
  };
  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-cart-open]")) { e.preventDefault(); drawer.open(); }
    if (e.target.closest("[data-cart-close]") || e.target.closest(".nv-drawer-backdrop")) drawer.close();
    const rm = e.target.closest("[data-line-remove]");
    if (rm) drawer.change(rm.closest(".nv-line").dataset.key, 0);
    const qc = e.target.closest("[data-qty-change]");
    if (qc) {
      const line = qc.closest(".nv-line");
      const current = parseInt(line.querySelector(".nv-qty span").textContent, 10);
      drawer.change(line.dataset.key, Math.max(0, current + parseInt(qc.dataset.qtyChange, 10)));
    }
  });
  drawer.refresh();

  /* ── Card quick add (homepage/collection cards) ── */
  document.addEventListener("click", async (e) => {
    const btn = e.target.closest("[data-quick-add]");
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    const res = await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.quickAdd, 10), quantity: 1 }] }) });
    btn.disabled = false;
    if (res.ok) { toast("Added to bag"); drawer.open(); } else toast("Could not add to bag");
  });

  /* ── Countdown to midnight ── */
  const countdowns = document.querySelectorAll("[data-countdown]");
  if (countdowns.length) {
    const tick = () => {
      const now = new Date(); const end = new Date(now); end.setHours(23, 59, 59, 999);
      let s = Math.max(0, Math.floor((end - now) / 1000));
      const t = `${String(Math.floor(s / 3600)).padStart(2, "0")}:${String(Math.floor((s % 3600) / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;
      countdowns.forEach(el => el.textContent = t);
    };
    tick(); setInterval(tick, 1000);
  }

  /* ── Accordions ── */
  document.addEventListener("click", (e) => {
    const head = e.target.closest(".nv-acc-head");
    if (head) head.closest(".nv-acc-item").classList.toggle("open");
    const fc = e.target.closest(".nv-fincmp-head");
    if (fc) fc.closest(".nv-fincmp").classList.toggle("open");
    const rm = e.target.closest("[data-readmore]");
    if (rm) {
      const desc = document.querySelector("[data-desc]");
      const open = !desc.classList.contains("clamped");
      desc.classList.toggle("clamped", open);
      rm.classList.toggle("open", !open);
      rm.querySelector("span").textContent = open ? "Read more" : "Read less";
      const fade = document.querySelector(".nv-desc-fade");
      if (fade) fade.style.display = open ? "" : "none";
    }
  });

  /* ── Panel collections carousel ── */
  document.querySelectorAll("[data-panels]").forEach(wrap => {
    const track = wrap.querySelector(".nv-panels-track");
    const dots = wrap.querySelectorAll(".nv-dots button");
    if (!track) return;
    let idx = 0, paused = false;
    const go = (i) => {
      idx = ((i % track.children.length) + track.children.length) % track.children.length;
      const card = track.children[idx];
      if (card) track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: "smooth" });
      dots.forEach((d, j) => d.classList.toggle("active", j === idx));
    };
    dots.forEach((d, i) => d.addEventListener("click", () => go(i)));
    wrap.querySelector("[data-car-prev]")?.addEventListener("click", () => go(idx - 1));
    wrap.querySelector("[data-car-next]")?.addEventListener("click", () => go(idx + 1));
    wrap.addEventListener("mouseenter", () => paused = true);
    wrap.addEventListener("mouseleave", () => paused = false);
    track.addEventListener("touchstart", () => { paused = true; }, { passive: true });
    track.addEventListener("touchend", () => setTimeout(() => paused = false, 3000), { passive: true });
    setInterval(() => { if (!paused && !document.hidden) go(idx + 1); }, 2000);
  });

  /* ── Testimonials carousel ── */
  document.querySelectorAll("[data-testi]").forEach(wrap => {
    const slides = wrap.querySelectorAll(".nv-testi-slide");
    const imgs = wrap.querySelectorAll(".nv-testi-img img");
    const dots = wrap.querySelectorAll(".nv-testi-dots button");
    const bar = wrap.querySelector(".nv-testi-bar i");
    if (!slides.length) return;
    let idx = 0, paused = false, timer;
    const show = (i) => {
      idx = ((i % slides.length) + slides.length) % slides.length;
      slides.forEach((s, j) => s.classList.toggle("active", j === idx));
      imgs.forEach((im, j) => im.classList.toggle("active", j === idx));
      dots.forEach((d, j) => d.classList.toggle("active", j === idx));
      if (bar) { bar.classList.remove("run"); void bar.offsetWidth; if (!paused) bar.classList.add("run"); }
    };
    const start = () => { clearInterval(timer); timer = setInterval(() => { if (!paused && !document.hidden) show(idx + 1); }, 3000); };
    wrap.querySelector("[data-testi-prev]")?.addEventListener("click", () => { show(idx - 1); start(); });
    wrap.querySelector("[data-testi-next]")?.addEventListener("click", () => { show(idx + 1); start(); });
    dots.forEach((d, i) => d.addEventListener("click", () => { show(i); start(); }));
    wrap.addEventListener("mouseenter", () => { paused = true; if (bar) bar.classList.remove("run"); });
    wrap.addEventListener("mouseleave", () => { paused = false; show(idx); });
    wrap.addEventListener("touchstart", () => { paused = true; }, { passive: true });
    show(0); start();
  });

  /* ── Videos: play when visible ── */
  try {
    const vio = new IntersectionObserver((entries) => {
      entries.forEach(en => { const v = en.target; if (en.isIntersecting) v.play().catch(() => {}); else v.pause(); });
    }, { threshold: 0.3 });
    document.querySelectorAll("video[data-inview]").forEach(v => vio.observe(v));
  } catch (e) {}

  /* ── PDP gallery ── */
  const gal = document.querySelector("[data-gallery]");
  if (gal) {
    const main = gal.querySelector("[data-main-image]");
    const thumbs = gal.querySelectorAll(".nv-thumb");
    let gi = 0;
    const setImg = (i) => {
      gi = ((i % thumbs.length) + thumbs.length) % thumbs.length;
      const t = thumbs[gi];
      if (t) { main.src = t.dataset.full; thumbs.forEach((x, j) => x.classList.toggle("active", j === gi)); }
    };
    thumbs.forEach((t, i) => t.addEventListener("click", () => setImg(i)));
    gal.querySelector("[data-gal-prev]")?.addEventListener("click", () => setImg(gi - 1));
    gal.querySelector("[data-gal-next]")?.addEventListener("click", () => setImg(gi + 1));
  }

  /* ── Compare dialog + info popovers ── */
  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-dialog-open]")) document.querySelector("[data-dialog]")?.classList.add("open");
    if (e.target.closest("[data-dialog-close]") || e.target === document.querySelector("[data-dialog]")) document.querySelector("[data-dialog]")?.classList.remove("open");
    const infoBtn = e.target.closest("[data-info-toggle]");
    document.querySelectorAll(".nv-fpop.open").forEach(p => { if (!infoBtn || p !== infoBtn.parentElement.querySelector(".nv-fpop")) p.classList.remove("open"); });
    if (infoBtn) {
      e.preventDefault(); e.stopPropagation();
      infoBtn.parentElement.querySelector(".nv-fpop")?.classList.toggle("open");
    }
    if (e.target.closest("[data-info-close]")) e.target.closest(".nv-fpop").classList.remove("open");
  });

  /* ═══════════ PRODUCT CONFIGURATOR ═══════════ */
  const pdp = document.querySelector("[data-product-form]");
  if (pdp) {
    let data;
    try { data = JSON.parse(document.getElementById("nv-product-json").textContent); } catch (e) { data = null; }
    if (data) {
      const variants = data.variants;
      const optionNames = data.options;
      const state = { selections: {}, frameColor: null, touched: {} };
      const isFinishName = (n) => ["finish", "material", "product type", "type"].includes(n.toLowerCase());
      const finishName = optionNames.find(isFinishName) || null;
      const frameStep = pdp.querySelector("[data-frame-step]");

      const first = variants.find(v => v.available) || variants[0];
      if (first) optionNames.forEach((n, i) => state.selections[n] = first.options[i]);

      const variantsWith = (name, value, holdOthers) => {
        const i = optionNames.indexOf(name);
        return variants.filter(v => {
          if (v.options[i] !== value) return false;
          if (!holdOthers) return true;
          return optionNames.every((n, j) => n === name || v.options[j] === state.selections[n]);
        });
      };
      const currentVariant = () => variants.find(v => optionNames.every((n, i) => v.options[i] === state.selections[n])) || null;
      const priceDelta = (name, value) => {
        let pool = variantsWith(name, value, true); if (!pool.length) pool = variantsWith(name, value, false);
        if (!pool.length) return null;
        const mine = Math.min(...pool.map(v => v.price));
        const i = optionNames.indexOf(name);
        const values = [...new Set(variants.map(v => v.options[i]))];
        let base = Infinity;
        values.forEach(val => {
          let p = variantsWith(name, val, true); if (!p.length) p = variantsWith(name, val, false);
          if (p.length) base = Math.min(base, Math.min(...p.map(v => v.price)));
        });
        return mine - base;
      };
      const isFramedSelected = () => finishName && (state.selections[finishName] || "").toLowerCase().includes("framed");
      const selectionComplete = () => optionNames.every(n => state.touched[n]) && (!isFramedSelected() || !!state.frameColor);

      function render() {
        const v = currentVariant();
        const priceEls = pdp.querySelectorAll("[data-price]");
        if (v) priceEls.forEach(el => el.textContent = money(v.price));
        const cmp = pdp.querySelector("[data-compare-price]");
        const savePill = pdp.querySelector("[data-save-pill]");
        if (cmp && v) {
          const has = v.compare_at_price && v.compare_at_price > v.price;
          cmp.style.display = has ? "" : "none";
          if (has) cmp.textContent = money(v.compare_at_price);
          if (savePill) {
            savePill.style.display = has ? "" : "none";
            if (has) savePill.textContent = "Save " + Math.round((1 - v.price / v.compare_at_price) * 100) + "%";
          }
        }
        // steps done markers
        pdp.querySelectorAll("[data-step-num]").forEach(el => {
          const n = el.dataset.stepNum;
          const done = n === "Frame Color" ? !!state.frameColor : !!state.touched[n];
          el.classList.toggle("done", done);
          el.innerHTML = done ? '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M20 6 9 17l-5-5"/></svg>' : el.dataset.idx;
        });
        // options
        pdp.querySelectorAll("[data-opt]").forEach(btn => {
          const name = btn.dataset.optName, value = btn.dataset.optValue;
          btn.classList.toggle("selected", !!state.touched[name] && state.selections[name] === value);
          const exists = isFinishName(name) ? variantsWith(name, value, false).length > 0 : variantsWith(name, value, true).length > 0;
          btn.classList.toggle("unavailable", !exists);
          const d = btn.querySelector("[data-delta]");
          if (d) {
            const delta = priceDelta(name, value);
            if (delta === null || Math.abs(delta) < 1) { d.textContent = btn.classList.contains("nv-fcard") ? "Included" : ""; d.classList.add("incl"); }
            else { d.textContent = (delta > 0 ? "+" : "−") + moneyRound(Math.abs(delta)); d.classList.remove("incl"); }
          }
        });
        // frame step
        if (frameStep) {
          frameStep.style.display = isFramedSelected() && state.touched[finishName] ? "" : "none";
          frameStep.querySelectorAll("[data-frame-color]").forEach(b => b.classList.toggle("selected", b.dataset.frameColor === state.frameColor));
        }
        // summary
        const sum = pdp.querySelector("[data-summary]");
        if (sum) {
          const parts = [];
          optionNames.forEach(n => { if (state.touched[n]) parts.push(state.selections[n]); });
          if (isFramedSelected() && state.frameColor) parts.push(state.frameColor + " frame");
          sum.style.display = parts.length ? "" : "none";
          const tgt = sum.querySelector("[data-summary-text]");
          if (tgt) tgt.textContent = parts.join(" · ");
        }
        // CTA
        const ok = selectionComplete() && v && v.available;
        const atc = pdp.querySelector("[data-add-to-bag]");
        if (atc) atc.disabled = !ok;
        const hint = pdp.querySelector("[data-selection-hint]");
        if (hint) hint.style.display = selectionComplete() ? "none" : "";
        // variant image swap
        if (v && v.featured_image) {
          const main = document.querySelector("[data-main-image]");
          if (main) main.src = v.featured_image.src;
        }
      }

      pdp.addEventListener("click", (e) => {
        const opt = e.target.closest("[data-opt]");
        if (opt && !opt.classList.contains("unavailable")) {
          const name = opt.dataset.optName, value = opt.dataset.optValue;
          state.selections[name] = value;
          state.touched[name] = true;
          if (isFinishName(name)) {
            if (!currentVariant()) {
              const fb = variantsWith(name, value, false)[0];
              if (fb) optionNames.forEach((n, i) => { if (n !== name) state.selections[n] = fb.options[i]; });
            }
            if (!value.toLowerCase().includes("framed")) state.frameColor = null;
          }
          render();
        }
        const fc = e.target.closest("[data-frame-color]");
        if (fc) { state.frameColor = fc.dataset.frameColor; render(); }
      });

      async function addToCart() {
        const v = currentVariant();
        if (!v) return false;
        const body = { items: [{ id: v.id, quantity: 1, properties: state.frameColor ? { "Frame Color": state.frameColor } : undefined }] };
        const res = await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });
        return res.ok;
      }
      pdp.querySelector("[data-add-to-bag]")?.addEventListener("click", async (e) => {
        e.preventDefault();
        const btn = e.currentTarget; btn.disabled = true;
        if (await addToCart()) {
          btn.classList.add("added");
          const orig = btn.innerHTML;
          btn.innerHTML = "✓ Added to Cart";
          drawer.open();
          setTimeout(() => { btn.classList.remove("added"); btn.innerHTML = orig; render(); }, 2500);
        } else { toast("Could not add to bag."); }
        btn.disabled = false;
        render();
      });
      render();
    }
  }
})();
